import { IconButton, makeStyles } from "@material-ui/core"
import { icon_peopleMinus, icon_peoplePlus } from "../../assets/images/images";
import { IMenuItem } from "../../interface/interface";

const useStyles = makeStyles((theme: any) => ({
    numberOfPeopleContainer: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        width: 'min-content',
        '& > *':{
            padding: 0
        }
    },
    numberOfPeopleInput: {
        outline: 'none',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        fontSize: 26,
        textAlign: 'center',
        width: 40,
        '& > *':{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%'
        }
    },
}));

interface Props {
    menuItemOnDate: IMenuItem;
    menuItemsOnDate: IMenuItem[];
    menuItemsOnDates?: IMenuItem[][];
    setMenuItemsOnDates?: React.Dispatch<React.SetStateAction<IMenuItem[][]>>;
    index?: number;
}

export const NumberOfPeopleInputButton: React.FC<Props> = ({
    menuItemOnDate,
    menuItemsOnDate,
    menuItemsOnDates,
    setMenuItemsOnDates,
    index
}) => {
    const classes = useStyles()

    const updateSelectedDishes = (alterCount: number) => {
        const newMenuItems: IMenuItem [] = [];
        menuItemsOnDate.forEach( (selectMenuItemsOnDateItem) => {
            if(selectMenuItemsOnDateItem.dish.content.id === menuItemOnDate.dish.content.id){
                selectMenuItemsOnDateItem.quantity = selectMenuItemsOnDateItem.quantity + alterCount;
            }
            newMenuItems.push(selectMenuItemsOnDateItem)
        });
        if(menuItemsOnDates && setMenuItemsOnDates){
            const tmpMenuItemsOnDate : IMenuItem[][] = []
            menuItemsOnDates.forEach((menuItemsOnDate,i) => {
                if(index === i){
                    tmpMenuItemsOnDate.push(newMenuItems)
                } else {
                    tmpMenuItemsOnDate.push(menuItemsOnDate)
                }
            })
    
            if(tmpMenuItemsOnDate.length > 0){
                setMenuItemsOnDates(tmpMenuItemsOnDate)
            }
        }
    }

    const handleQuantityChange = (tmpQuantity: string) => {
        const quantity = parseInt(tmpQuantity)

        const newMenuItems: IMenuItem [] = [];
        if(menuItemsOnDates && setMenuItemsOnDates && index){
            menuItemsOnDates[index].forEach( (selectMenuItemsOnDateItem) => {
                if(selectMenuItemsOnDateItem.dish.content.id === menuItemOnDate.dish.content.id){
                    if(quantity=== NaN){
                        selectMenuItemsOnDateItem.quantity = quantity
                    } else if(tmpQuantity.length > 1 && quantity=== 0){
                        selectMenuItemsOnDateItem.quantity = 0
                    } else if(quantity >= 99 || tmpQuantity.length > 2){
                        selectMenuItemsOnDateItem.quantity = 99
                    } else {
                        selectMenuItemsOnDateItem.quantity = quantity
                    }
                }
                newMenuItems.push(selectMenuItemsOnDateItem)
            });
            
            // Set menuItemsOnDates
            const tmpMenuItemsOnDate : IMenuItem[][] = []
            menuItemsOnDates.forEach((menuItemsOnDate,i) => {
                if(index=== i){
                    tmpMenuItemsOnDate.push(newMenuItems)
                } else {
                    tmpMenuItemsOnDate.push(menuItemsOnDate)
                }
            })
    
            if(tmpMenuItemsOnDate.length > 0){
                setMenuItemsOnDates(tmpMenuItemsOnDate)
            }
        }
    }
    
    return (
        <div className={classes.numberOfPeopleContainer}>
            <IconButton aria-label="add an alarm" onClick={() => updateSelectedDishes(-1)} disabled={menuItemOnDate.quantity=== 0}>
                <img src={icon_peopleMinus}/>
            </IconButton>
            <input 
                className={classes.numberOfPeopleInput} 
                value={menuItemOnDate.quantity} 
                type="number"
                onChange={(e) => {handleQuantityChange(e.target.value)}} 
                onBlur={(e) => {e.target.value=== "" && handleQuantityChange("0")}}>
            
            </input>
            <IconButton color="secondary" aria-label="add an alarm" onClick={() => updateSelectedDishes(+1)}>
                <img src={icon_peoplePlus}/>
            </IconButton>
        </div>
    )
}